module.exports = __webpack_public_path__ + "images/dick-pix-pro-cc32e02a53721ec3d53fb1c680bd9255.png";